import { createStore, createHook } from "react-sweet-state";

const Store = createStore({
  // value of the store on initialisation
  initialState: {
    isLoading: false,
    leftMenu:true
  },
  // actions that trigger store mutation
  actions: {
    changeMode:
      () =>
      async ({ setState, getState }) => {
        setState({ leftMenu: !getState().leftMenu});

      },
  },
  // optional, mostly used for easy debugging
  name: "listOfAdministrator",
});

export const usePageSettingHeaderStore = createHook(Store);
